import { CoinsMain } from '../../components/CoinsMain';
import { SummaryMain } from '../../components/SummaryMain';

export const MainPage = () => {
   return (
      <>
         <SummaryMain />
         <CoinsMain />
      </>
   );
};
